import { type FC } from 'react'
import { type HeroProps } from './Hero.interface'
import styles from './Hero.module.scss'
import { RichText } from '../RichText/RichText'

export const Hero: FC<HeroProps> = ({ title, text }) => (
  <div className={styles.container}>
    <h1 className={styles.title}>{title}</h1>
    { text && <RichText richtext={text} /> }
  </div>
)
